// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__EbXlK","top":"style_top__TbXhc","closeButton":"style_closeButton__LaVxM"};